import ComplaintView from './ComplaintView';

export default ComplaintView;
